module.exports = __webpack_public_path__ + "sz.svg?dee254bf0c34149f6764f432c6519f29";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sz.svg
// module id = 1139
// module chunks = 27